<template>
  <div>
    <!-- -->
    <div class="marsTiltPanel marsTiltPanel-theme-blue">
      <img @click="closePanel" class="img-close" src="../../assets/GB.png" />
      <div class="marsTiltPanel-wrap">
        <div class="area">
          <div class="arrow-lt"></div>
          <div class="b-t"></div>
          <div class="b-r"></div>
          <div class="b-b"></div>
          <div class="b-l"></div>
          <div class="arrow-rb"></div>
          <div class="label-wrap">
            <PublicForm :width="'100px'" :formData="formData" :formList="cols" />
          </div>
        </div>
        <div class="b-t-l"></div>
        <div class="b-b-r"></div>
      </div>
      <div class="arrow"></div>
    </div>
  </div>
</template>

<script>
import { getCommonAjax } from "@/api/common";
export default {
  props: ["subData"],
  data() {
    return {
      formData: {},
      cols: [
        {
          label: "ICAO码:",
          cusprop: "icao",
          component: "popContent",
        },
        {
          label: "呼号:",
          cusprop: "callNumber",
          component: "popContent",
        },
        {
          label: "应答机编号:",
          cusprop: "transponder",
          component: "popContent",
        },
        {
          label: "定位时间:",
          cusprop: "updateTime",
          component: "popContent",
        },
        {
          label: "爬升率:",
          cusprop: "rateClimb",
          component: "popContent",
        },
        {
          label: "经度:",
          cusprop: "longitude",
          component: "popContent",
        },
        {
          label: "纬度:",
          cusprop: "latitude",
          component: "popContent",
        },
        {
          label: "高程(米):",
          cusprop: "altitude",
          component: "popContent",
        },
        {
          label: "速度(km/h):",
          cusprop: "speed",
          component: "popContent",
        },
        {
          label: "航向:",
          cusprop: "direction",
          component: "popContent",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    closePanel() {
      this.$parent.close();
    },
    updateOther(item, curPos) {
      if (!this.formData || !this.formData) {
        return;
      }
      //console.log(item)
      if (item) {
        if (!curPos) {
          curPos = {
            x: item.longitude,
            y: item.latitude,
            z: item.altitude,
          };
        }
        let lon_arr = this.formatDegree(Number(curPos.x));
        let lat_arr = this.formatDegree(Number(curPos.y));
        this.formData.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
        this.formData.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
        this.formData.altitude = Number(curPos.z).toFixed(2);
        this.formData.speed = item.speed;
        this.formData.updateTime = item.updateTime;
        this.formData.rateClimb = item.rateClimb;
        this.formData.direction = item.direction;

        console.log(this.formData);
      }
    },
    update(x, y, z, item) {
      if (this.hasData) {
        return;
      }
      if (!this.formData) {
        return;
      }

      let lon_arr = this.formatDegree(x);
      let lat_arr = this.formatDegree(y);

      this.formData.longitude = `${lon_arr[0]}°${lon_arr[1]}′${lon_arr[2]}″`;
      this.formData.latitude = `${lat_arr[0]}°${lat_arr[1]}′${lat_arr[2]}″`;
      this.formData.altitude = Number(z).toFixed(2);

      if (item) {
        this.formData.speed = item.speed;
        this.formData.createTime = item.createTime;
      }
      // if (!item) {
      //   let s = this.getRandomInt(200, 300);
      //   this.formData.deviceLocation.speed = s.toFixed(0);
      //   this.hasData = true;
      // }
      // this.addFJLX();
      // this.addTIME();
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getData() {
      this.formData = this.subData;
    },

    formatDegree(value) {
      value = Math.abs(value);
      var v1 = Math.floor(value); //度
      var v2 = Math.floor((value - v1) * 60); //分
      var v3 = Math.round(((value - v1) * 3600) % 60); //秒
      return [v1, v2, v3];
    },
  },
};
</script>

<style scoped>
.marsTiltPanel-wrap {
  position: relative;
  padding: 30px;
  overflow: hidden;
}
.marsTiltPanel .img-close {
  width: 26px;
  position: absolute;
  right: 12px;
  top: 10px;
  z-index: 999;
  cursor: pointer;
  pointer-events: all;
}
.marsTiltPanel-theme-blue .area {
  background-image: linear-gradient(
      135deg,
      transparent 30px,
      #28bbf06c 30px,
      #28bbf06c 50%,
      transparent 50%
    ),
    linear-gradient(
      -45deg,
      transparent 30px,
      #28bbf06c 30px,
      #28bbf06c 50.1%,
      transparent 50%
    );
}

.marsTiltPanel .area {
  position: relative;
  min-width: 180px;
}

.marsTiltPanel-theme-blue .b-t,
.marsTiltPanel-theme-blue .b-r,
.marsTiltPanel-theme-blue .b-b,
.marsTiltPanel-theme-blue .b-l,
.marsTiltPanel-theme-blue .b-t-l,
.marsTiltPanel-theme-blue .b-b-r {
  background-color: #29baf1;
  box-shadow: 0 0 10px 2px #29baf1;
}

.marsTiltPanel .b-t {
  position: absolute;
  top: 0;
  left: 44px;
  right: 0;
  height: 1px;
  z-index: 10;
}

.marsTiltPanel .b-r {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 44px;
  width: 1px;
  z-index: 10;
}

.marsTiltPanel .b-b {
  position: absolute;
  left: 0;
  right: 44px;
  bottom: 0;
  height: 1px;
  z-index: 10;
}

.marsTiltPanel .b-l {
  position: absolute;
  top: 44px;
  left: 0;
  bottom: 0;
  width: 1px;
  z-index: 10;
}

.marsTiltPanel .b-t-l {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 62px;
  transform: rotate(45deg) translate(52px, -22px);
  z-index: 10;
}
.marsTiltPanel .b-b-r {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 1px;
  height: 62px;
  transform: rotate(45deg) translate(-52px, 22px);
  z-index: 10;
}
.marsTiltPanel .label-wrap {
  padding-left: 12px;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
}

.marsTiltPanel .label-wrap {
  padding-left: 12px;
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
}

.marsTiltPanel-theme-blue .arrow,
.marsTiltPanel-theme-blue .title::before {
  background-color: #28bbf0;
}

.marsTiltPanel .arrow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 45px;
  height: 2px;
  transform: rotate(-45deg) translate(5px, -15px);
}
</style>
